RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.TitleDropdown = Marionette.Dashboard.views.LayoutView.extend({
        template: '#commonTitleDropdownTemplate',
        tagName: 'h1',

        childEvents: {
            'navItem:action': 'onTitleAction'
        },

        triggers: {
            'click .x-edit': 'title:edit'
        },

        regions: {
            title: '.x-title-region',
            dropdown: {
                selector: '.dropdown',
                regionClass: Marionette.Region.extend({
                    attachHtml: function (view) {
                        this.$el.append(view.$el);
                    }
                })
            }
        },

        onRenderLoaded: function () {
            const me = this;

            if (me.model.get('titleView')) {
                me.title.show(me.model.get('titleView'));
            }

            const hasEditButton = Boolean(me.model.get('hasEditButton'));

            if (hasEditButton || me.collection.length) {
                const hasItems = (me.collection.length > 0);
                if (hasEditButton) {
                    if (_.get(me.collection.first(), 'attributes.value') !== '__edit') {
                        me.collection.add({
                            value: '__edit',
                            className: 'edit',
                            display: me.model.get('titleViewEditName') || 'Edit',
                            action: function () {
                                const editAction = me.model.get('editAction');
                                if (editAction) {
                                    return editAction();
                                } else {
                                    me.triggerMethod('title:edit');
                                }
                            }
                        }, {
                            at: 0
                        });

                        if (hasItems) {
                            me.collection.add({
                                className: 'divider'
                            }, {
                                at: 1
                            });
                        }
                    }
                }

                const DropdownViewClass = me.getDropdownViewClass(hasEditButton, hasItems);
                me.dropdown.show(new DropdownViewClass({
                    collection: me.collection
                }));
            }
        },

        getDropdownViewClass: function (hasEditButton, hasItems) {
            return Marionette.CollectionView.extend({
                childViewEventPrefix: 'navItem',
                tagName: 'ul',
                className: 'title-dropdown dropdown-menu',
                childView: views.TitleDropdownItem,
                attachHtml: function (collectionView, childView, index) {
                    if (hasEditButton) {
                        if (hasItems) {
                            if (index === 2) {
                                $('<ul />').addClass('dropdown-scrollable').appendTo(collectionView.el);
                            }
                            if (index > 1) {
                                return childView.$el.appendTo(collectionView.el.querySelector('ul:last-child'));
                            }
                        }
                    }

                    childView.$el.appendTo(collectionView.el);
                }
            });
        },

        templateHelpers: function () {

            const me = this;
            const title = me.model.get('title') || me.model.get('name');
            const hasMenuItems = me.collection.size() > 0;
            const hasEditButton = Boolean(me.model.get('hasEditButton'));

            return {
                title: title,
                hasMenuItems: hasMenuItems,
                hasEditButton: hasEditButton
            };
        },

        onTitleAction: function (view, event) {
            const me = this;
            const data = _.extend({
                view: view
            }, event);
            me.trigger('title:action', data);
        },

        getTitle: function () {
            const me = this;
            return me.model.get('title');
        }
    });

});
